import {Component, computed, inject, input, PLATFORM_ID} from '@angular/core';
import {SessionTopic} from '../../../../model/session.model';
import {DynamicScriptDirective} from '../../../../common/directive/dynamic-script.directive';
import {HomeDigitsComponent} from '../../home/home-digits/home-digits.component';
import {HomeFaqComponent} from '../../home/home-faq/home-faq.component';
import {HomeProgramComponent} from '../../home/home-program/home-program.component';
import {isPlatformBrowser, NgClass, NgForOf, NgIf} from '@angular/common';
import {PageFooterComponent} from '../../common/page/page-footer/page-footer.component';
import {SessionContentComponent} from '../content/session-content.component';
import {SessionTestimoniesComponent} from '../testimonies/session-testimonies.component';
import {ShowEventDate} from '../../../../common/pipe/showEventDate.pipe';
import {SocialTrackService} from '../../../../services/social-track.service';
import {RouterLink} from '@angular/router';
import {MatchTestimonyComponent} from '../../common/match-testimony/match-testimony.component';
import {SessionDTO} from '@minutespourtoi/api-models/dist/models';
import {SessionSubscribedDTOWithUid} from '../../../../data/dto/session.dto';
import {WelcomeVideoService} from '../../../../services/welcome-video.service';


@Component({
  selector: 'app-show-content',
  imports: [
    DynamicScriptDirective,
    HomeDigitsComponent,
    HomeFaqComponent,
    HomeProgramComponent,
    NgForOf,
    NgIf,
    PageFooterComponent,
    SessionContentComponent,
    SessionTestimoniesComponent,
    ShowEventDate,
    RouterLink,
    NgClass,
    MatchTestimonyComponent
  ],
  templateUrl: './show-content.component.html'
})
export class ShowContentComponent {

  socialTrackService = inject(SocialTrackService)
  welcomeVideoService = inject(WelcomeVideoService)
  session = input<SessionDTO>()
  topic = input<SessionTopic>()
  stayingPlaces = input<number>()
  subscribedPeople = input<Array<SessionSubscribedDTOWithUid>>()
  isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  state = computed<'full' | 'unknown' | 'available'>(() => {
    const stayingPlaces = this.stayingPlaces();
    if (stayingPlaces === null || !this.isBrowser) return 'unknown';
    return stayingPlaces === 0 ? 'full' : 'available';
  });

  label = computed(() => {
    switch (this.state()) {
      case 'full':
        return { title: "Liste d'attente", detail: 'Complet' };
      case 'unknown':
        return { title: 'Je réserve', detail: 'Places limitées · 10,90€' };
      default:
        return { title: 'Je réserve', detail: `${this.stayingPlaces()} place(s) restante(s)` };
    }
  });

  ngAfterViewInit() {
    this.welcomeVideoService.loadVideo()
  }

  trackById(index: number, item: SessionSubscribedDTOWithUid) {
    return item.__uid;
  }
  trackByItem(index: number, item: string) {
    return item;
  }

}
